export const CRIMINAL_RECORD_TITLE_TOOLTIP =
    'This report may contain information from the following sources:- Department of Corrections, Court Records, Arrest Logs and Sexual Offender Records. Coverage varies by state. The public records and commercially available data sources compiled in this report may have errors. Data is sometimes entered poorly, processed incorrectly and is generally not free from defect. This report should not be relied upon as definitively accurate. Before relying on any data from this report, it should be independently verified. The criminal record data in this report may include records that have been expunged, sealed, or otherwise have become inaccessible to the public since the date on which the data was last updated or collected.';

export const SHOW_RECORDS_TYPE = {
    SOC_RECORDS: 'socRecords',
    GWC_RECORDS: 'gwcRecords',
};

export const SHOW_RECORDS_HEADING = {
    [SHOW_RECORDS_TYPE.SOC_RECORDS]: 'Sex Offender Check',
    [SHOW_RECORDS_TYPE.GWC_RECORDS]: 'Global Watchlist Check',
};

export const SHOW_RECORDS_ERR_MSG = {
    [SHOW_RECORDS_TYPE.SOC_RECORDS]: {
        COMPLETE: 'The user has no sex offender records matching their information.',
        PENDING: 'Check is in progress',
    },

    [SHOW_RECORDS_TYPE.GWC_RECORDS]:
        'The user has no global watchlist records matching their information',
};

export const BG_CHECK_TYPE = {
    SOC: 'SOC',
    GWC: 'GWC',
};

export const WARNING_POPUP_TITLE = {
    [BG_CHECK_TYPE.SOC]: 'Sex Offender Check Pro?',
    [BG_CHECK_TYPE.GWC]: 'Run Global Watchlist Report?',
};

export const GWC_NUDGE = {
    success: {
        desc: 'No Matching Records Found',
        cta: false,
    },
    cancel: {
        desc: 'Matching Record Found',
        cta: true,
    },
};

export const SOC_NUDGE = {
    success: {
        desc: 'No Matching Records Found',
    },
    cancel: {
        desc: 'Matching Record Found',
    },
    warning: {
        desc: 'Check is in progress',
    },
};

export const TWO_FA_NUDGE_STATUES = {
    PENDING: 'jwt_nudge',
    SUCCESS: 'success',
    WARNING: 'warning',
    FAIL: 'failure',
};

export const TWO_FA_NUDGE_STATES = {
    MISSING_EMAIL: 'MISSING_EMAIL',
    MISSING_PHONE: 'MISSING_PHONE',
    MISSING_EMAIL_AND_PHONE: 'MISSING_EMAIL_AND_PHONE',
    EMAIL_AND_PHONE_SUCCESS: 'EMAIL_AND_PHONE_SUCCESS',
    EMAIL_SUCCESS: 'EMAIL_SUCCESS',
    PHONE_SUCCESS: 'PHONE_SUCCESS',
    EMAIL_FAIL: 'EMAIL_FAIL',
    PHONE_FAIL: 'PHONE_FAIL',
    EMAIL_AND_PHONE_FAIL: 'EMAIL_AND_PHONE_FAIL',
};

export const TWO_FA_NUDGE_ACTION_LABEL = {
    [TWO_FA_NUDGE_STATES.MISSING_EMAIL]: 'Update Email',
    [TWO_FA_NUDGE_STATES.MISSING_PHONE]: 'Update Phone',
    [TWO_FA_NUDGE_STATES.MISSING_EMAIL_AND_PHONE]: 'Update Email & Phone',
    VIEW_RESULT: 'View Results',
};

export const TWO_FA_NUDGE_DESCRIPTIONS = {
    [TWO_FA_NUDGE_STATES.MISSING_EMAIL]:
        'Workflow has 2FA enabled. Please provide the user’s email to proceed.',
    [TWO_FA_NUDGE_STATES.MISSING_PHONE]:
        'Workflow has 2FA enabled. Please provide the user’s phone number to proceed.',
    [TWO_FA_NUDGE_STATES.MISSING_EMAIL_AND_PHONE]:
        'Workflow has 2FA enabled. Please provide the user’s phone number and Email to proceed.',
    [TWO_FA_NUDGE_STATES.EMAIL_AND_PHONE_SUCCESS]:
        '2FA was successfully completed using phone number and email.',
    [TWO_FA_NUDGE_STATES.EMAIL_SUCCESS]: '2FA was successfully completed using email.',
    [TWO_FA_NUDGE_STATES.PHONE_SUCCESS]: '2FA was successfully completed using phone number.',
    [TWO_FA_NUDGE_STATES.EMAIL_FAIL]: 'User failed 2FA through email.',
    [TWO_FA_NUDGE_STATES.PHONE_FAIL]: 'User failed 2FA through phone number.',
    [TWO_FA_NUDGE_STATES.EMAIL_AND_PHONE_FAIL]: 'User failed 2FA through phone number and email.',
};

export const MAP_TWO_FA_RESULT_KEYS = {
    email: 'Email',
    email_verified: 'Verified',
    phone: 'Phone Number',
    phone_verified: 'Verified',
};
